/**
 * OOFOS Size Guide Modal — Horizon Theme
 * Rebuilt to match the OOFOS reference layout:
 *   - Stacked WOMEN / MEN / UNISEX measurement blocks
 *   - Each block has its own mm/in toggle + "How To Measure Your Foot" link
 *   - A fixed label column with US / UK / EU country flags
 *   - A horizontally scrollable foot-length / size table
 *   - A "Find Your Size" instructions block with image
 * Data comes from dto--size-guide.liquid (#oofos-size-guide-data).
 */
(function () {
  'use strict';

  var sizeData = [];
  var schema = {};
  var footUnits = ['mm', 'in'];
  var sizeUnits = ['US', 'UK', 'EU'];
  var unitByGender = {};
  var modal = null;

  function qs(s, c) { return (c || document).querySelector(s); }
  function qsa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"]/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch];
    });
  }

  // ─── Boot ──────────────────────────────────────────────────────────────────
  function init() {
    if (document.getElementById('oofos-size-guide-modal')) return; // build once

    var dataEl = document.getElementById('oofos-size-guide-data');
    if (dataEl) {
      try {
        var parsed = JSON.parse(dataEl.textContent);
        sizeData = parsed.sizes || [];
        schema = parsed.schema || {};
      } catch (e) { console.warn('[SizeGuide] data parse error', e); }
    }
    footUnits = (schema.footLengthUnits && schema.footLengthUnits.length) ? schema.footLengthUnits : ['mm', 'in'];
    sizeUnits = (schema.sizeUnits && schema.sizeUnits.length) ? schema.sizeUnits : ['US', 'UK', 'EU'];

    modal = buildModal();
    document.body.appendChild(modal);
    bindModalEvents();

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-size-guide-trigger]');
      if (trigger) { e.preventDefault(); openModal(); }
    });
  }

  // ─── Flag sprite (defined once inside the modal) ───────────────────────────
  function flagSprite() {
    var stars = '';
    var cx = 12, cy = 9, r = 5.6;
    for (var i = 0; i < 12; i++) {
      var a = (Math.PI / 6) * i - Math.PI / 2;
      stars += '<circle cx="' + (cx + r * Math.cos(a)).toFixed(2) + '" cy="' + (cy + r * Math.sin(a)).toFixed(2) + '" r="0.85" fill="#FFCC00"/>';
    }
    return '' +
      '<svg width="0" height="0" style="position:absolute" aria-hidden="true" focusable="false">' +
        '<symbol id="oofos-flag-us" viewBox="0 0 24 18">' +
          '<rect width="24" height="18" fill="#fff"/>' +
          '<g fill="#b22234"><rect width="24" height="2" y="0"/><rect width="24" height="2" y="4"/><rect width="24" height="2" y="8"/><rect width="24" height="2" y="12"/><rect width="24" height="2" y="16"/></g>' +
          '<rect width="10" height="10" fill="#3c3b6e"/>' +
        '</symbol>' +
        '<symbol id="oofos-flag-uk" viewBox="0 0 24 18">' +
          '<rect width="24" height="18" fill="#012169"/>' +
          '<path d="M0,0 24,18 M24,0 0,18" stroke="#fff" stroke-width="3.6"/>' +
          '<path d="M0,0 24,18 M24,0 0,18" stroke="#C8102E" stroke-width="2.1"/>' +
          '<path d="M12,0 V18 M0,9 H24" stroke="#fff" stroke-width="6"/>' +
          '<path d="M12,0 V18 M0,9 H24" stroke="#C8102E" stroke-width="3.6"/>' +
        '</symbol>' +
        '<symbol id="oofos-flag-eu" viewBox="0 0 24 18">' +
          '<rect width="24" height="18" fill="#003399"/>' + stars +
        '</symbol>' +
      '</svg>';
  }

  // ─── Modal shell ───────────────────────────────────────────────────────────
  function buildModal() {
    var el = document.createElement('div');
    el.id = 'oofos-size-guide-modal';
    el.className = 'oofos-sg-modal';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', schema.title || 'Size Guide');
    el.hidden = true;
    el.innerHTML =
      '<div class="oofos-sg-overlay"></div>' +
      '<div class="oofos-sg-container">' +
        flagSprite() +
        '<button class="oofos-sg-close" type="button" aria-label="Close Size Guide">&#x2715;</button>' +
        '<div class="oofos-sg-header"><h2 class="oofos-sg-title">' + esc(schema.title || 'Size Guide') + '</h2></div>' +
        '<div class="oofos-sg-body"></div>' +
      '</div>';
    return el;
  }

  function bindModalEvents() {
    qs('.oofos-sg-overlay', modal).addEventListener('click', closeModal);
    qs('.oofos-sg-close', modal).addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  function openModal() {
    renderBody();
    modal.hidden = false;
    document.body.classList.add('oofos-sg-open');
    setTimeout(function () { qs('.oofos-sg-close', modal).focus(); }, 50);
  }

  function closeModal() {
    modal.hidden = true;
    document.body.classList.remove('oofos-sg-open');
  }

  // ─── Render ────────────────────────────────────────────────────────────────
  function genders() {
    var hasUnisex = sizeData.some(function (r) { return (r.unisex || '').replace(/\|/g, '').trim() !== ''; });
    return [
      { key: 'womens', title: schema.womenTitle || 'Women', desc: schema.womenDescription, show: true },
      { key: 'mens', title: schema.menTitle || 'Men', desc: schema.menDescription, show: true },
      { key: 'unisex', title: schema.unisexTitle || 'Unisex', desc: schema.unisexDescription, show: hasUnisex }
    ].filter(function (g) { return g.show; });
  }

  function lenFor(row, unit) {
    var parts = (row.foot_length || '').split('|');
    var idx = footUnits.indexOf(unit);
    if (idx < 0) idx = 0;
    return parts[idx] || parts[0] || '';
  }

  function flagId(unit) {
    var u = unit.toUpperCase();
    if (u === 'US') return 'oofos-flag-us';
    if (u === 'UK') return 'oofos-flag-uk';
    if (u === 'EU') return 'oofos-flag-eu';
    return null;
  }

  function renderGender(g) {
    var unit = unitByGender[g.key] || footUnits[0];
    unitByGender[g.key] = unit;

    var unitBtns = footUnits.map(function (u) {
      return '<button type="button" class="oofos-sg-unit' + (u === unit ? ' is-active' : '') +
        '" data-unit="' + esc(u) + '">' + esc(u) + '</button>';
    }).join('');

    var leftRows = sizeUnits.map(function (u) {
      var fid = flagId(u);
      var flag = (schema.enableFlags !== false && fid)
        ? '<svg class="oofos-sg-flag" viewBox="0 0 24 18" aria-hidden="true"><use href="#' + fid + '" xlink:href="#' + fid + '"></use></svg>'
        : '';
      return '<tr><td class="oofos-sg-cell-label">' + flag +
        '<span class="oofos-sg-label">' + esc(u + ' ' + g.title) + '</span></td></tr>';
    }).join('');

    var headCells = sizeData.map(function (row) {
      return '<th class="oofos-sg-len">' + esc(lenFor(row, unit)) + '</th>';
    }).join('');

    var bodyRows = sizeUnits.map(function (u, ui) {
      var cells = sizeData.map(function (row) {
        var v = (row[g.key] || '').split('|')[ui] || '';
        return '<td class="oofos-sg-size">' + (v ? esc(v) : '&mdash;') + '</td>';
      }).join('');
      return '<tr>' + cells + '</tr>';
    }).join('');

    return '' +
      '<section class="oofos-sg-gender" data-gender="' + g.key + '">' +
        '<h3 class="oofos-sg-gender-title">' + esc(g.title) + '</h3>' +
        (g.desc ? '<p class="oofos-sg-gender-desc">' + esc(g.desc) + '</p>' : '') +
        '<div class="oofos-sg-controls">' +
          '<div class="oofos-sg-units" role="group" aria-label="' + esc(g.title) + ' units">' + unitBtns + '</div>' +
          '<a class="oofos-sg-howto-link" href="#oofos-sg-instructions" data-howto>' + esc(schema.howToLabel || 'How To Measure Your Foot') + '</a>' +
        '</div>' +
        '<div class="oofos-sg-tables">' +
          '<table class="oofos-sg-table-left">' +
            '<thead><tr><th class="oofos-sg-foot-th">' + esc(schema.footLengthTitle || 'Foot Length') + '</th></tr></thead>' +
            '<tbody>' + leftRows + '</tbody>' +
          '</table>' +
          '<div class="oofos-sg-table-right-wrap">' +
            '<table class="oofos-sg-table-right">' +
              '<thead><tr>' + headCells + '</tr></thead>' +
              '<tbody>' + bodyRows + '</tbody>' +
            '</table>' +
          '</div>' +
        '</div>' +
      '</section>';
  }

  function renderInstructions() {
    var blocks = '';
    for (var i = 1; i <= 3; i++) {
      var h = schema['header' + i];
      var d = schema['description' + i];
      if ((h && h.trim()) || (d && d.trim())) {
        blocks += '<div class="oofos-sg-instr-block">' +
          (h ? '<h3>' + esc(h) + '</h3>' : '') +
          (d ? '<div class="oofos-sg-instr-desc">' + d + '</div>' : '') +
          '</div>';
      }
    }
    if (!blocks) return '';

    var imgSrc = typeof schema.image === 'string' ? schema.image : (schema.image && schema.image.src);
    var img = imgSrc
      ? '<div class="oofos-sg-instr-img"><img src="' + esc(imgSrc) + '" alt="' + esc(schema.imageAlt || '') + '" loading="lazy"></div>'
      : '';

    return '<div class="oofos-sg-instructions" id="oofos-sg-instructions">' +
      '<div class="oofos-sg-instr-text">' + blocks + '</div>' + img + '</div>';
  }

  function renderBody() {
    var body = qs('.oofos-sg-body', modal);
    body.innerHTML = genders().map(renderGender).join('') + renderInstructions();

    qsa('.oofos-sg-unit', body).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var section = btn.closest('.oofos-sg-gender');
        if (section) setUnit(section.getAttribute('data-gender'), btn.dataset.unit);
      });
    });

    qsa('[data-howto]', body).forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var t = qs('#oofos-sg-instructions', body);
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function setUnit(genderKey, unit) {
    unitByGender[genderKey] = unit;
    var section = qs('.oofos-sg-gender[data-gender="' + genderKey + '"]', modal);
    if (!section) return;
    qsa('.oofos-sg-unit', section).forEach(function (b) {
      b.classList.toggle('is-active', b.dataset.unit === unit);
    });
    var ths = qsa('.oofos-sg-table-right thead th', section);
    sizeData.forEach(function (row, i) { if (ths[i]) ths[i].textContent = lenFor(row, unit); });
  }

  // ─── Run ───────────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
